import { useState } from "react";
import SelectionComponent from "./Component/SelectionComponent";
import SelectionGrupComponent from "./Component/SelectionGrupComponent";
import SelectionGrupSecComponent from "./Component/SelectionGrupSecComponent.js";
import useGlobal from "../../../util/Global.js";

const KriterGroupItem = ({ kriter, selKriterler, onChange }) => {

    const { t } = useGlobal();
    const [grupkriterId, setGrupKriterId] = useState(null);
    const [grupkriterAdi, setGrupKriterAdi] = useState(null);

    const onChangeKriterGrubu = (kriterGrubuId, kriterId, kriterAdi) => {
        console.log(kriterGrubuId, kriterId, kriterAdi);

        setGrupKriterId(kriterId);
        setGrupKriterAdi(kriterAdi);
    }

    const handleSelectionChange = (kriterId, kriterGrubuId, selectionId, selectionName) => {
        console.log(kriterId, kriterGrubuId, selectionId, selectionName);

        if (kriterId && selectionId) {
            onChange(kriterId, selectionId, selectionName, grupkriterAdi, true);
        }

    }

    return (<>
        <SelectionGrupComponent
            key={kriter.kriterGrubuId}
            kriterGrubuId={kriter.kriterGrubuId}
            kriterGrubuAdi={kriter.kriterModul.display}
            parentKriterId={kriter.kriterModul.anneKriterId}
            bagliOlunanKriterId={kriter.kriterModul.bagliOlunanKriterId}
            bagliOlunanKriterSecenekId={kriter.kriterModul.bagliOlunanKriterSecenekId}
            parentSecenekId={selKriterler[kriter.kriterModul.anneKriterId]?.value}
            selKriterler={selKriterler}
            zorunlu={kriter.zorunlu}
            onChange={onChangeKriterGrubu}
        />

        <SelectionGrupSecComponent
            kriterId={grupkriterId}
            kriterGrubuId={kriter.kriterGrubuId}
            label={t("col.dilKriterSelection")}
            zorunlu={true}
            onChange={handleSelectionChange}
        />

    </>);

}

export default KriterGroupItem;